// extracted by mini-css-extract-plugin
module.exports = {"cls1":"OutsideLink-Link-module--cls1--12gPF","cls2":"OutsideLink-Link-module--cls2--TFPgY OutsideLink-Link-module--cls1--12gPF"};